import { render, staticRenderFns } from "./ThirdStepIronPalace.vue?vue&type=template&id=6f8f5037&scoped=true&"
import script from "./ThirdStepIronPalace.vue?vue&type=script&lang=js&"
export * from "./ThirdStepIronPalace.vue?vue&type=script&lang=js&"
import style0 from "./ThirdStepIronPalace.vue?vue&type=style&index=0&id=6f8f5037&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8f5037",
  null
  
)

export default component.exports